"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableMeta = exports.RESERVED_ROOT_NAME = void 0;
const stylable_utils_1 = require("./stylable-utils");
const stylable_value_parsers_1 = require("./stylable-value-parsers");
exports.RESERVED_ROOT_NAME = 'root';
class StylableMeta {
    constructor(ast, diagnostics) {
        this.ast = ast;
        this.diagnostics = diagnostics;
        this.globals = {};
        const rootSymbol = {
            _kind: 'class',
            name: exports.RESERVED_ROOT_NAME,
            [stylable_value_parsers_1.valueMapping.root]: true,
        };
        this.rawAst = ast.clone();
        this.source = stylable_utils_1.getSourcePath(ast, diagnostics);
        this.root = exports.RESERVED_ROOT_NAME;
        this.namespace = '';
        this.imports = [];
        this.vars = [];
        this.cssVars = {};
        this.keyframes = [];
        this.elements = {};
        this.classes = {
            [exports.RESERVED_ROOT_NAME]: rootSymbol,
        };
        this.mappedSymbols = {
            [exports.RESERVED_ROOT_NAME]: rootSymbol,
        };
        this.customSelectors = {};
        this.urls = [];
        this.scopes = [];
        this.simpleSelectors = {};
        this.mixins = [];
        this.transformDiagnostics = null;
    }
}
exports.StylableMeta = StylableMeta;
//# sourceMappingURL=stylable-meta.js.map